<template>
    <div v-if="Intl.DateTimeFormat().resolvedOptions().timeZone === 'Europe/Paris'">
        <div class="app-quicklinks-itpdf_pathem" style="margin-top: 10px !important;">
            <a v-on:click="showModal" :categorie="categorie" :libelle="libelle" :pe="pe"
               action="Callback"
               class="app-quicklink LnkWcbForm-trigger BT_ACTION mb-2"><span
                class="app-quicklink-text">Je souhaite être appelé</span>
                <svg width="28" height="28" class="app-quicklink-icon app-icon">
                    <use xlink:href="/images/lunaweb/app/sprite.svg#sprite-appele"></use>
                </svg>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "WebCallBackStickyComponent",

    props: {
        "categorie": {type: String},
        "pe": {type: String},
        "libelle": {type: String},
    },

    methods: {
        showModal() {
            this.$root.$emit('openModal', this.categorie, this.pe);
        }
    }
}

</script>

<style scoped>

</style>
